import { Component } from '@angular/core';
import { FpcsTableComponent } from 'src/app/components/fpcs-table/fpcs-table.component';
import { HeaderComponent } from 'src/app/components/header/header.component';

@Component({
  selector: 'app-fpcs',
  imports: [FpcsTableComponent, HeaderComponent],
  templateUrl: './fpcs.component.html',
  styleUrl: './fpcs.component.scss'
})
export class FpcsComponent {}
